import { EntityAudit } from "@modernary/mui/components/audit";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

const names = {
  permits: "Permit.Permits",
  list: "Permit.PermitList",
  base: "Permit.PermitBase",
  view: "Permit.PermitView,",
  new: "Permit.PermitNew",
  edit: "Permit.PermitEdit",
  permitWellChildList: "Permit.PermitWellChildList",
  notes: "Permit.PermitNotes",
  noteEdit: "Permit.PermitNoteEdit",
  noteNew: "Permit.PermitNoteNew",
  documents: "Permit.PermitDocuments",
  documentEdit: "Permit.PermitDocumentEdit",
  documentNew: "Permit.PermitDocumentNew",
  audit: "Permit.PermitAudit",
  versions: "Permit.PermitVersions",
  versionNew: "Permit.PermitVersionNew",
  versionEdit: "Permit.PermitVersionEdit",
  modifyRenewPermitVersion: "Permit.PermitModifyRenewPermitVersion",
  addPermitWells: "Permit.PermitWellEdit",
  removePermitWell: "Permit.PermitWellRemove",
};

export { names as permitRouteNames };

const permitRoutes: RouterOptions["routes"] = [
  {
    path: "/permits",
    name: names.permits,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Permits", lookupGroups: ["Staff", "PermitStatus"] },
        component: () => import("@/views/permit/PermitList.vue"),
      },
      {
        path: "new/:facilityId(\\d+)?",
        component: () => import("@/views/permit/PermitBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "Permit New", isNew: true },
            component: () => import("@/views/permit/PermitEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/permit/PermitBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Permit View" },
            component: () => import("@/views/permit/PermitView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Permit Edit", isForm: true },
            component: () => import("@/views/permit/PermitEdit.vue"),
          },
          {
            path: "permitwells",
            name: names.permitWellChildList,
            meta: { title: "Permitted Wells" },
            component: () => import("@/views/permit/PermitWellChildList.vue"),
          },

          {
            path: "permitWellEdit",
            name: names.addPermitWells,
            meta: { title: "Permit Well Edit", isForm: true },
            component: () => import("@/views/permit/PermitWellEdit.vue"),
          },
          {
            path: "permitWellRemove/:permitWellId(\\d+)",
            name: names.removePermitWell,
            meta: { title: "Permit Well Edit", isForm: true },
            component: () => import("@/views/permit/RemovePermitWell.vue"),
          },
          {
            path: "versions",
            name: names.versions,
            meta: { title: "Permit Versions" },
            component: () => import("@/views/permit/PermitVersionChildList.vue"),
          },
          {
            path: "versions/:versionId(\\d+)",
            name: names.versionEdit,
            meta: { title: "Edit Permit Version", isForm: true },
            component: () => import("@/views/permit/PermitVersionEdit.vue"),
          },
          {
            path: "versions/new",
            name: names.versionNew,
            meta: { title: "Create Permit Version", isForm: true },
            component: () => import("@/views/permit/PermitVersionEdit.vue"),
          },
          {
            path: "modifyVersion/:versionId(\\d+)",
            name: names.modifyRenewPermitVersion,
            meta: { title: "Modify Permit", isForm: true },
            component: () => import("@/views/permit/ModifyRenewPermitVersion.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Permit Notes" },
            component: {
              render: () => <EntityNotes idField="permitId" routeNamePrefix="Permit.PermitNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Permit Note Edit", isForm: true },
            component: () => import("@/views/permit/PermitNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Permit Note New", isForm: true },
            component: () => import("@/views/permit/PermitNote.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Permit Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="permit" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Edit Permit Document", isForm: true },
            component: {
              render: () => <EntityDocumentForm resourceTypeKey="permit" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Create Permit Document", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm resourceTypeKey="permit" />,
            },
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Permit Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="Permit" />,
            },
          },
        ],
      },
    ],
  },
];
export default permitRoutes;
